export default __webpack_public_path__ + "static/media/img-4837.47ad1265.jpeg";